<template>
    <div>
        <slot />
        <div class="table-responsive">
            <table ref="selectableTable" class="table b-table table-striped table-hover" :style="customColor">
                <thead>
                    <tr>
                        <th v-for="field in fields" :class="field.tdClass" :key="field.key">
                            <span v-if="!!field.label">
                                <span v-html="field.label"></span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredItems" :key="item.hash">
                    
                        <td role="cell" aria-colindex="1" class="table-b-table-default b-table-sticky-column">
                            <div role="group" class="btn-group btn-group-sm"></div>
                        </td>
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td>{{ item.name }}</td>
                        <td>
                            <span v-if="item.description" style="font-weight: bold">
                                {{ item.description }}
                            </span>
                            <ul class="dashed">
                                <li v-if="item.task_notes">
                                    {{('notes')}}:
                                    <span style="font-weight: bold"> </span>
                                    {{ item.task_notes }}
                                </li>
                                <li v-if="item.task_value">
                                    {{('value')}}:
                                    <span style="font-weight: bold"> </span>
                                    {{ item.task_value }}
                                </li>
                                <li v-if="item.assets && item.assets.length" v-html="displayAssets(item.assets)"></li>
                            </ul>
                        </td>
                        <td v-if="item.order_item_type_id !== 3">
                            {{ item.uom }}
                        </td>
                        
                        <td class="text-right">{{ item.quantity }}</td>
                        <td class="text-right" v-if="item?.item_type?.is_task !== 1">
                            {{ item.price | currency }}
                        </td>
                        <td class="text-right" v-if="item?.item_type?.is_task !== 1">
                            {{ calculateItemTax(item) | currency }}
                        </td>
                        <td class="text-right" v-if="item?.item_type?.is_task !== 1">
                            {{ calculateItemCost(item) | currency }}
                        </td>
                        <td class="text-right" v-if="item.order_item_type_id == 2 ||
                        item?.item_type?.is_task == 1
                            ">
                            <b-form-checkbox value="true" unchecked-value="false" :checked="!!item.task_checked" disabled>
                            </b-form-checkbox>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-displayAccordionItems',
    data: () => ({
        criteria: null,
        type: null,
        isAssignment: true,
        text: 'Sample Text',
    }),
    props: ['filteredItems', 'customerAssets', 'itemTypeId', 'displaySelect'],
    mixins: [popupMixins, permissionsMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },

        formatLocation(s) {
            s = s || {}
            s.location = s.location || {}
            return `${s.name}, ${s.location.address1}, ${s.location.city}`
        },

        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + '!important',
                color: data.text_color + '!important',
            }
            return colors
        },
        order() {
            const order = this.$store.state.orders.item
            console.log('computed---order', order)
            //Emit Order Completeion Status
            this.$emit('order-status', order.completed)
            console.log('computed---order--status', order.completed)
            return { ...(order || {}) }
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {
            console.log(
                '---------------------------------------------------------- '
            )
            /*
>>>> When I select product (is order item?) It should display No, Name, Details, UOM, Qty, Price, Tax , Total

When I select services ( is order item and task type) it should display:
 No, Name, Details , UOM, QTY, Price, Tax , Total, Check mark if completed, add a description field and put measurement name, value, and any notes if anything is contained in the field

When I select task (task type) it should display No, Name, Details , Check mark if completed, add a description field and put measurement name, value, and any  notes if anything is contained in the field

            */

            const _fields = [
                { key: 'id', label: '', stickyColumn: true },
                { key: 'index', label: this.$translate('no') },
                { key: 'name', label: this.$translate('name') },
                { key: 'details', label: this.$translate('details') },
            ]
            const product_fields = [
                { key: 'uom', label: this.$translate('uom') },
                { key: 'quantity', label: this.$translate('quantity') },
                {
                    key: 'price',
                    label: this.$translate('price'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: this.$translate('tax'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: this.$translate('total'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ]
            const service_fields = [
                { key: 'uom', label: this.$translate('uom') },
                { key: 'quantity', label: this.$translate('quantity') },
                {
                    key: 'price',
                    label: this.$translate('price'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: this.$translate('tax'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: this.$translate('total'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: this.$translate('completed'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                }
            ]
            const task_fields = [
                {
                    key: 'original_quantity',
                    label: this.$translate('quantity'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: this.$translate('completed'),
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ]

            console.log(
                '88888888888 Type Category 88888888888 [ ',
                this.itemTypeId,
                ' ]'
            )

            const type = this.itemTypes.find(x => x.id === this.itemTypeId)
            console.log('Type Name: ', type.name)
            console.log('!!! TYPE ', type)
            if (this.isTask(this.itemTypeId)) {
                _fields.push(...task_fields)
                console.log('888888888888 TASK', _fields)
            }
            if (this.isProduct(this.itemTypeId)) {
                _fields.push(...product_fields)
                console.log('888888888888 PRODUCT', _fields)
            }
            if (this.isService(this.itemTypeId)) {
                _fields.push(...service_fields)
                console.log('888888888888 SERVICE', _fields)
            }

            return _fields
            // return product_fields
        },
    },
    watch: {
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },
    },
    mounted() {
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
    },
    methods: {
        deleteItem(hash) {
            console.log('hash', hash)
            this.$store.dispatch('orderItemStore/delete', hash)
        },

        calculateItemCost(item) {
            /*  const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {} */

            return (
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            )
        },

        calculateItemTax(item) {
            /*  const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {} */

            let itemCost =
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const { customerAssets } = this
            console.log('displayAssets ids', ids)
            console.log('displayAssets customerAssets', ids)

            const assets = ids
                .map(id => customerAssets.find(asset => asset.id == id))
                .filter(x => !!x)

            const _html = assets.reduce((_str, asset, idx, _list) => {
                const { name, serial_no } = asset
                if (idx === 0) {
                    _str = `<b>Asset${_list.length > 0 ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${name}${serial_no ? '-' + serial_no : ''
                    }`
                return _str
            }, '')
            return _html
        },

        isProduct(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            //is_order_item and NOT is_task
            console.log(
                'IS ORDER: ',
                type.is_order_item,
                'Is TASK: ',
                type.is_task
            )
            return type.is_order_item == 1 && type.is_task == 0
        },
        isService(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            //is_order_item & is_task
            console.log(
                'IS ORDER: ',
                type.is_order_item,
                'Is TASK: ',
                type.is_task
            )

            return type.is_order_item == 1 && type.is_task == 1
        },
        isTask(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            // NOT is_order_item AND is_task
            console.log(
                'IS ORDER: ',
                type.is_order_item,
                'Is TASK: ',
                type.is_task
            )
            return type.is_order_item == 0 && type.is_task == 1
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}

ul.dashed {
    list-style-type: none;
}

ul.dashed>li {
    text-indent: -30px;
}

ul.dashed>li:before {
    content: '';
    text-indent: -30px;
}
</style>
